import { useTranslation } from 'react-i18next';

import { ArbitrageDesinvestissableItem, ArbitrageInvestissableItem } from '@/api/placementApi.schemas';
import ArbitrageCards, { ArbitrageSupport } from '@/components/ArbitrageCards/ArbitrageCards';

type ArbitrageCardsSectionProps = {
  supportsDesinvestis: ArbitrageDesinvestissableItem[];
  supportsInvestis: ArbitrageInvestissableItem[];
};

const isUninvested = (support: ArbitrageSupport): support is ArbitrageDesinvestissableItem =>
  'montantNetDetenu' in support;

const isInvested = (support: ArbitrageSupport): support is ArbitrageInvestissableItem =>
  'montantNetAInvestir' in support;

const ArbitrageCardsSection = ({ supportsDesinvestis, supportsInvestis }: ArbitrageCardsSectionProps) => {
  const { t } = useTranslation();

  return (
    <>
      <ArbitrageCards
        supports={supportsDesinvestis}
        title={t('summaryArbitrage.supportsDesinvestis')}
        isInvested={false}
        getMontant={(support) => (isUninvested(support) ? (support.montantDesinvesti ?? null) : null)}
      />
      <ArbitrageCards
        supports={supportsInvestis}
        title={t('summaryArbitrage.supportsInvestis')}
        isInvested
        getMontant={(support) => (isInvested(support) ? (support.montantNetAInvestir ?? null) : null)}
      />
    </>
  );
};

export default ArbitrageCardsSection;
